import { create } from 'zustand'

// Modo preview: o portal foi aberto dentro de um iframe pelo ERP (staff),
// com sessao read-only da conta de preview. Usado para esconder UI de escrita
// (a RLS ja bloqueia, isto e a camada de UX) e mostrar a faixa de aviso.
export const usePreviewStore = create((set) => ({
  isPreview: false,
  sessionReady: false,
  setPreview: (isPreview) => set({ isPreview }),
  setSessionReady: (sessionReady) => set({ sessionReady }),
}))

export function useIsPreview() {
  return usePreviewStore((s) => s.isPreview)
}

// Barra escritas em modo preview antes de bater no banco (a RLS tambem bloqueia,
// isto da uma mensagem amigavel em vez de erro cru). Use no inicio de mutationFns.
export function assertNotPreview() {
  if (usePreviewStore.getState().isPreview) {
    throw new Error('Modo preview: ações de escrita estão desativadas.')
  }
}
